import { render, staticRenderFns } from "./PreRegister.vue?vue&type=template&id=edb32450&scoped=true&"
import script from "./PreRegister.vue?vue&type=script&lang=js&"
export * from "./PreRegister.vue?vue&type=script&lang=js&"
import style0 from "./PreRegister.vue?vue&type=style&index=0&id=edb32450&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb32450",
  null
  
)

export default component.exports